export const DEFAULT_VIEWS = [
	{ id: "all", code: "all", flowName: "All" },
	{ id: "assignedToMe", code: "assignedToMe", flowName: "Assigned to Me" }
];
